<template>
<div :class="$style['select-for-labels']">
    <pt-page-search @search="search" @emptySearch="emptySearch" :searchKey="searchKey" :isAddrouter="false"></pt-page-search>
    <pt-page-menu-filter :isRouteQuery="false" :tabs="labelTypes" v-model="selectTab" :isStringArr="true" label-name="name" value-name="id" :is-route-query="false" @select="selectTabs"></pt-page-menu-filter>
    <pt-select-list @getTableData="getTableData" :maxPage="5"  :page-size="pageSize" :table-data="tableData" :tableLabels="tableLabels" :total-count="totalCount" @selected="selected"
    keys="name" showName="name" :selectedRows="select_labels" ref="selectList" showBeforParams="type" v-loading="loading"></pt-select-list>
    <div class="button-div">
            <el-button type="primary" @click="submit">选择</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
</div>
</template>
<script>

import ptSelectList from 'cps/base/pt-select-list'
import { labelTypes, goodsTableLables } from '../../recommend-manage/pt-label-manage/label-option'
export default {
  name: 'select-for-labels',
  components: {
    ptSelectList
  },
  props: {
    selectLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      labelTypes: labelTypes,
      selectTab: labelTypes[0],
      pageSize: 10,
      tableLabels: goodsTableLables,
      totalCount: 0,
      tableData: [],
      selectRow: JSON.parse(JSON.stringify(this.selectLabels)),
      select_labels: JSON.parse(JSON.stringify(this.selectLabels)),
      searchKey: '',
      loading: false
    }
  },
  watch: {
    selectLabels: {
      handler: function (val) {
        this.select_labels = JSON.parse(JSON.stringify(val))
        this.searchKey = ''
      }
    }
  },
  methods: {
    search (key) {
      this.searchKey = key
      this.getTableData(0)
    },
    emptySearch () {
      this.searchKey = ''
      this.getTableData(0)
    },
    selectTabs (val) {
      this.selectTab = val
      this.searchKey = ''
      this.getTableData(0)
      this.$refs.selectList.reset()
    //   this.$refs.selectList.tabSwitch()
    },
    selected (val) {
      this.selectRow = JSON.parse(JSON.stringify(val))
      this.select_labels = JSON.parse(JSON.stringify(this.selectRow))
      this.$emit('selectMealRow', val)
    },
    cancel () {
      this.$emit('close')
    },
    submit (val) {
      this.$emit('selectLabelsSubmit', JSON.parse(JSON.stringify(this.selectRow)))
    },
    getTableData (page, next) {
      if (this.searchKey) {
        this.labelListByName(page, next)
      } else {
        this.getLabelsList(page, next)
      }
    },
    getLabelsList (page, next) {
      let data = {
        example: {
          type: this.selectTab
        },
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getLabelsList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalCount = res.totalNumber
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$refs.tabelPage.showReTry()
        this.$message.error(err || '获取商品列表失败')
      })
    },
    labelListByName (page, next) {
      let data = {
        example: {
          name: this.searchKey,
          type: this.selectTab
        },
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('labelListByName', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.loading = false
        this.tableData = res.data
        this.totalCount = res.totalNumber
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '搜索标签失败')
      })
    }
  },
  created () {
  }

}
</script>
<style module lang="less">
.select-for-labels{

}
</style>
